// extracted by mini-css-extract-plugin
var _1 = "LibraryIcon__bgColor--DSboF";
var _2 = "LibraryIcon__color--D9EFy";
var _3 = "LibraryIcon__disabled--THCJJ LibraryIcon__main--wXgY1";
var _4 = "LibraryIcon__disabledColor--z7m8m";
var _5 = "LibraryIcon__main--wXgY1";
var _6 = "LibraryIcon__svg--r0p3f";
export { _1 as "bgColor", _2 as "color", _3 as "disabled", _4 as "disabledColor", _5 as "main", _6 as "svg" }
